import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import QuoteBand from './components/QuoteBand';
import WhySection from './components/WhySection';
import ModulesSection from './components/ModulesSection';
import StatsBand from './components/StatsBand';
import LaunchSection from './components/LaunchSection';
import OutcomesSection from './components/OutcomesSection';
import PresenterSection from './components/PresenterSection';
import TestimonialSection from './components/TestimonialSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import './index.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <QuoteBand />
      <WhySection />
      <ModulesSection />
      <StatsBand />
      <LaunchSection />
      <OutcomesSection />
      <PresenterSection />
      <TestimonialSection />
      <PricingSection />
      <FAQSection />
      <FinalCTA />
      <Footer />
    </div>
  );
}

export default App;
